//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dialogMixin from '@/mixin/dialog.js';
const QRCode = require('qrcode');

export default {
  name: 'ApplyDialog',
  mixins: [dialogMixin],
  props: {
    url: { type: String, default: '' },
    title: { type: String, default: '' },

    ownerName: { type: String, default: '' },
    jobName: { type: String, default: '' },
  },
  data() {
    return {
      qrCodeShow: false,
      resultQrcode: false,
    };
  },
  computed: {
    labelWidth() {
      if (process.browser) {
        return window.innerWidth > 768 ? 'auto' : '';
      }
    },
  },
  methods: {
    onClickOk() {
      if (this.resultQrcode) {
        this.qrCodeShow = true;
        this.$nextTick(() => {
          var canvas = document.getElementById('qrcode');
          QRCode.toCanvas(canvas, this.url, function (error) {
            if (error) console.error(error);
            console.log('success!');
          });
        });
      } else {
        window.location.replace(this.url);
      }
    },
    onClose() {
      this.close();
    },
    onOpen() {
      let vw = document.documentElement.clientWidth;
      if (vw > 768) {
        this.resultQrcode = true;
      }
    },
  },
};
